import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const { settings, categories } = useApp();

  return (
    <footer className="bg-navy text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-2xl font-bold text-gold mb-4">GPGT</h3>
            <p className="text-gray-400 mb-4">Your trusted partner in construction materials and general trading across UAE.</p>
            <p className="text-gold font-arabic text-sm" dir="rtl">شريكك الموثوق في مواد البناء</p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Categories</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map(cat => (
                <li key={cat.id}>
                  <Link to={`/products?category=${cat.id}`} className="text-gray-400 hover:text-gold transition-colors">{cat.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/products" className="text-gray-400 hover:text-gold transition-colors">All Products</Link></li>
              <li><Link to="/cart" className="text-gray-400 hover:text-gold transition-colors">Shopping Cart</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-gold transition-colors">Contact Us</Link></li>
              <li><Link to="/login" className="text-gray-400 hover:text-gold transition-colors">My Account</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <p className="flex items-center gap-2 text-gray-400">
                <MapPin className="h-4 w-4 text-gold" />
                {settings.company_address || 'Dubai, UAE'}
              </p>
              <a href={`tel:${settings.company_phone}`} className="flex items-center gap-2 text-gray-400 hover:text-gold">
                <Phone className="h-4 w-4 text-gold" />
                {settings.company_phone || '+971 4 456 7890'}
              </a>
              <a href={`mailto:${settings.company_email}`} className="flex items-center gap-2 text-gray-400 hover:text-gold">
                <Mail className="h-4 w-4 text-gold" />
                {settings.company_email || 'info@gpgt.ae'}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-navy-light py-6">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">© 2025 Grand Palace General Trading. All rights reserved.</p>
          <p className="text-gray-500 text-sm">TRN: {settings.company_trn || 'TRN123456789'}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
